import { cloneDeep } from 'lodash-es';

import {
  fullNameSchema,
  fullNameUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

const updatedFullNameSchema = cloneDeep(fullNameSchema);
updatedFullNameSchema.properties.first.maxLength = 40;
updatedFullNameSchema.properties.last.maxLength = 50;

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['veteran-name-title']),
    veteranFullName: fullNameUI(),
  },
  schema: {
    type: 'object',
    required: [],
    properties: {
      veteranFullName: updatedFullNameSchema,
    },
  },
};
